import axios from "axios";

// Always use the current page's origin for API calls. Backend and frontend
// are served from the same host through the ingress, so any same-origin call
// avoids CORS preflights entirely. This also protects against production
// domain canonicalisation (e.g. www -> naked) which would otherwise break
// preflight requests. `REACT_APP_BACKEND_URL` is kept as a fallback for
// non-browser contexts (SSR / tests).
const BACKEND_URL =
  (typeof window !== "undefined" && window.location && window.location.origin) ||
  process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// CSRF defence: force every axios request to carry a custom header. Simple
// cross-origin form-POSTs from an attacker page cannot set custom headers
// without triggering a CORS preflight, which our origin regex rejects. The
// backend requires this header on every state-changing /api/ request
// (webhooks exempted, they carry Stripe-Signature / x-paystack-signature).
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

// Auth is cookie-based (httpOnly `access_token` / `session_token` set by the
// backend). Tokens are never persisted in localStorage — XSS-safe by design.

export default api;
